module.exports = __webpack_public_path__ + "static/silver-fc752c6c1e3aad4a1923cb5e388394d8.svg";